import script from "./FortuneWheelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FortuneWheelDialog.vue?vue&type=script&setup=true&lang=js"

import "./FortuneWheelDialog.vue?vue&type=style&index=0&id=5917f8b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5917f8b7"]])

export default __exports__